var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 72,
    viewBox: "0 0 29 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.65938 71C2.43161 71 2.22011 70.943 2.02488 70.8289C1.82965 70.7149 1.65069 70.5438 1.488 70.3157C1.16262 69.8596 0.999929 69.3008 0.999929 68.6393C0.999929 67.9778 1.16262 67.419 1.488 66.9629L23.7442 35.7605L1.78085 4.96872C1.45546 4.51254 1.29277 3.96514 1.29277 3.32649C1.29277 2.68784 1.45546 2.14044 1.78085 1.68427C2.10623 1.22809 2.50482 1 2.97663 1C3.44843 1 3.84703 1.22809 4.17241 1.68427L27.3071 34.1183C27.6325 34.5745 27.7952 35.1219 27.7952 35.7605C27.7952 36.3992 27.6325 36.9466 27.3071 37.4027L3.83076 70.3157C3.66806 70.5438 3.48097 70.7149 3.26947 70.8289C3.05797 70.943 2.85461 71 2.65938 71Z",
    fill: "#74F5A8",
    stroke: "#3B9860",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/ArrowRight.da36aabf.svg";
export { ForwardRef as ReactComponent };